import i18n from '../../../../base-dictionary';
import {
  graphLightRed,
  graphPictonBlue,
  graphSandyBrown,
  graphSunglow,
  graphTropicalIndigo,
  pinkBase,
  primaryBase,
} from '../../../../styles/design-tokens';
import { Phase } from './flow-by-phase-tab.type';

const PHASES: Phase[] = [
  Phase.Backlog,
  Phase.Blocked,
  Phase.Wip,
  Phase.Review,
  Phase.Test,
  Phase.Deployable,
  Phase.Done,
];

const PHASES_METADATA = [
  {
    id: Phase.Backlog,
    label: i18n.t('strategy.initiative_performance.phases.ready'),
    color: graphTropicalIndigo,
  },
  {
    id: Phase.Blocked,
    label: i18n.t('strategy.initiative_performance.phases.blocked'),
    color: graphLightRed,
  },
  {
    id: Phase.Wip,
    label: i18n.t('strategy.initiative_performance.phases.wip'),
    color: graphSandyBrown,
  },
  {
    id: Phase.Review,
    label: i18n.t('strategy.initiative_performance.phases.in_review'),
    color: graphSunglow,
  },
  {
    id: Phase.Test,
    label: i18n.t('strategy.initiative_performance.phases.in_test'),
    color: pinkBase,
  },
  {
    id: Phase.Deployable,
    label: i18n.t('strategy.initiative_performance.phases.to_deploy'),
    color: graphPictonBlue,
  },
  {
    id: Phase.Done,
    label: i18n.t('strategy.initiative_performance.phases.done'),
    color: primaryBase,
  },
];

export { PHASES, PHASES_METADATA };
